export class UserProfileModel {
  DisplayName:string;
  UserName:string;
  CustomerName:string;
  RoleList:string[];
  ProductAccess: string[];
  public allowedCustomerList: Array<{ text: string, value: number }> = [];
  SSOPortalAppId: string;
  SSOPortalURL: string;
  CustomerType: string;
  Email: string;
}
